﻿const axios = require('axios');

$('.Validate').click(function () {
    setTimeout(function () {
        $('.input-validation-error').each(function (i, e) {
            $(this).parent().addClass('form-error');
        });
    },
        200);
});
